import { Visibility, VisibilityOff } from "@mui/icons-material"
import DeleteIcon from '@mui/icons-material/Delete'
import EditNoteIcon from '@mui/icons-material/EditNote'
import { Autocomplete, Backdrop, Button, Divider, FormControl, FormControlLabel, Grid, IconButton, Radio, RadioGroup, Switch, TextField, Typography } from '@mui/material'
import axios from 'axios'
import { useFormik } from 'formik'
import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import * as yup from 'yup'
import CustomDataGrid from '../../../../../components/dataTable/customDataGrid'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import Loader from '../../../../../components/loader/loader'
import DeletePage from '../../../../../components/utils/deleteModal/deletePage'
import CustomTextField from '../../../../../components/utils/input/customTextField'
import Modal from '../../../../../components/utils/modal/modal'
import { Helmet } from "react-helmet-async"
const Users = () => {
  const dispatch = useDispatch()
    const pageOption = [10, 25, 50, 100]
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(100);
    // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const [search, setSearch] = useState('')
    const [open, setOpen] = useState(false)
    const [data, setData] = useState([])
    const [showPassword, setShowPassword] = useState(false);
    const [openDialog, setOpenDialog] = useState(false)
    const [activeId, setActiveId] = useState(null)
    const [isEdit, setIsEdit] = useState(false)
    const [outletData , setOutletData] = useState([])  //outlet data
    const [rolesData , setRolestData] = useState([])  //roles data
    const [isLoader, setIsLoader] = useState(false); //loader
const [userName , setUserName] = useState("")
    const validation = yup.object().shape({
      userName: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
      password: yup.string("Enter your password").min(8, "Password should be of minimum 8 characters length").required("Password is required"),
      // userType:yup.string().required('This field is required!'), 
      outletMapping:userName === "Warehouse" ?  yup.array().notRequired() :  yup.array().min(1, "Atleast select anyone type"),
      rolesMapping:yup.array().min(1, "Atleast select anyone type"),
      mobile:yup.string().matches(/^\S.*$/, "Empty space not allowed!") .matches(/^\d+$/, "Only digits are allowed")
      .required('This field is required!'),
      email: yup.string("Enter your email").email("Enter a valid email").required("This field is required!").test(
        'valid-domain',
        'Email domain should not contain symbols or numbers after @',
        (value) => {
          if (!value) return true; 
          const domainPart = value.split('@')[1];
          return /^[a-zA-Z.]+$/.test(domainPart);
        }
      ),
      userType: yup.string().required('This field is required!'),
    }) 
    
    const formik = useFormik({
        initialValues:{
          userName:"",
          password: "",
          email:"",
          // userType:"",
          mobile:"",
          outletMapping:[],
          rolesMapping:[],
          userType:""
        },
        validationSchema : validation,
        onSubmit : isEdit ? handleUpdate : handleCreate
      })

    const columns = [
        {
          field: "sno",
          headerName: "S.no",
          flex: 1,
          minWidth: 70,
          maxWidth: 100,
          headerAlign: "center",
          align: "center",
          sortable: false,
        },
        {
          field: "userName",
          headerName: "User Name",
          flex: 1,
          headerAlign: "center",
          align: "center",
          sortable: false,
        }, 
        {
          field: "mobile",
          headerName: "Mobile No.",
          flex: 1,
          headerAlign: "left",
          align: "left",
          sortable: false,
        },
        {
          field: "email",
          headerName: "Email",
          flex: 1,
          headerAlign: "left",
          align: "left",
          sortable: false,
        },
        {
          field: "user_type",
          headerName: "User Type",
          flex: 1,
          headerAlign: "center",
          align: "center",
          sortable: false,
        },
        // {
        //   field: "roles_name",
        //   headerName: "Assigned Roles",
        //   flex: 1,
        //   headerAlign: "center",
        //   align: "center",
        //   sortable: false,
        // },
        // {
        //   field: "isActive",
        //   headerName: "Status",
        //   flex: 1,
        //   headerAlign: "center",
        //   align: "center",
        //   sortable: false,
        //   disableColumnMenu: true,
        //   renderCell: (params) => (
        //     <div className="">
        //     <Switch checked={params.row.isActive} onClick={()=>console.log(params.row)} />
        //   </div>
        //   )
        // },
        
  {
    field: 'action',
    headerName: 'Action',
    flex: 1,
    minWidth: 100,
    headerAlign: "center",
    align: "center",
    editable: false,
    disableExport: true ,
    sortable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <div className='flex justify-center w-full'>
        <IconButton onClick={()=>onEdit(params.row)} >
          <EditNoteIcon sx={{color:"#1972d2",fontSize:22}}/>
        </IconButton>
        <IconButton onClick={() => OnDelete(params.id)}>
          <DeleteIcon sx={{color:"red",fontSize:22}}/>
        </IconButton>
      </div>
    ),
  },
      ];
    
      const rows = _.map(data, (val,idx)=>({
        id: val.id,
        sno: ++idx,
        userName: val.user_name,
        mobile: val.user_mobile,
        email: val.user_email,
        roles: val.roles,
        roles_name: _.map(val.roles, value=>value.role_name),
        outlets: val.outlets,
        user_type:val.user_type === 1 ? "Outlet" : "Warehouse"
      }))
      
      const props = {
        rows : rows,
        columns : columns,
        search : search,
        page: page,
        setPage : setPage,
        setSearch: setSearch,

        rowsPerPage : rowsPerPage,
        setRowsPerPage : setRowsPerPage,
        pageCount : pageCount,
        pageOption : pageOption
      }
      const onCreate = ()=>{
        setOpen(true)
        formik.resetForm()
        setIsEdit(false)
        }
      
      function handleCreate () {
        console.log("create")
        const roles = formik.values.rolesMapping.map(roleData => ({ role_id: roleData.id }));
        const outlets = formik.values.outletMapping.map(outData => ({ outlet_id: outData.id }));
        const userCreate = {    
          user_name:formik.values.userName,
          user_email:formik.values.email,
          user_mobile:formik.values.mobile,
          user_password:formik.values.password,
          company_id:1,
          roles : roles,
          outlets: outlets,
          user_type:formik.values.userType === "Outlet" ? 1 : 0
        }

        setIsLoader(true);
        axios.post('/v1/users',userCreate)
        .then(res=>{
          setOpen(false)
          getUsersData()
          dispatch(setSnackbar(true, 'success','Created Successfully!'))
          setOpen(false)
          setIsLoader(false);
        })
        .catch(err=>{
          console.log(err)
          dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
          setIsLoader(false);
        
        })
      }
      
      function onEdit(e){
        formik.resetForm()
        console.log(e)
        formik.setFieldValue('userName',e.userName)        
        formik.setFieldValue('userType',e.rolesMapping)
        formik.setFieldValue('email', e.email)
        formik.setFieldValue('mobile', e.mobile)
        const arr = []
        const arr2 = []
       _.map(e.roles, val=> _.filter(rolesData,value=>value.id===val.id).map(item=> arr.push(item)))
       formik.setFieldValue('rolesMapping', arr)
       _.map(e.outlets, val=>_.filter(outletData,value=> value.id=== val.id).map(item=>arr2.push(item)))
       formik.setFieldValue('outletMapping', arr2)
       formik.setFieldValue('userType' , e.user_type )
      setIsEdit(true)
      setOpen(true)
      setActiveId(e.id)
      }
      console.log(formik.values.userType === "Outlet" ? 1 : 0)
  function handleUpdate(){
    const roles = formik.values.rolesMapping.map(roleData => ({ role_id: roleData.id }));
    const outlets = formik.values.outletMapping.map(outData => ({ outlet_id: outData.id }));
    
            const userCreate = {
              
              user_name:formik.values.userName,
              user_email:formik.values.email,
              user_mobile:formik.values.mobile,
              user_password:formik.values.password,
              company_id:1,
              roles : roles,
            outlets: outlets,
            user_type:formik.values.userType === "Outlet" ? 1 : 0
            }
            setIsLoader(true);
    
    
            axios.put(`/v1/users/${activeId}`,userCreate)
            .then(res=>{
              setOpen(false)
              getUsersData()
              dispatch(setSnackbar(true, 'success','Updated Successfully!'))
              setOpen(false)
              setIsLoader(false);

            })
            .catch(err=>{
              console.log(err)
              dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
              setIsLoader(false);
            
            })
  }
  function handleActive(e){

    const roles = e.roles.map(roleData => ({ role_id: roleData.id }));
    const outlets = e.outlets.map(outData => ({ outlet_id: outData.id }));
    
            const userCreate = {
              
              user_name:e.userName,
              user_email:e.email,
              user_mobile:e.mobile,
              user_password:formik.values.password,
              company_id:1,
              roles : roles,
              user_type:formik.values.userType === "Outlet" ? 1 : 0,
            outlets: outlets
            }
            setIsLoader(true);
    
    
            axios.put(`/v1/users/${activeId}`,userCreate)
            .then(res=>{
              setOpen(false)
              getUsersData()
              dispatch(setSnackbar(true, 'success','Updated Successfully!'))
              setOpen(false)
              setIsLoader(false);

            })
            .catch(err=>{
              console.log(err)
              dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
              setIsLoader(false);
            
            })
  }
      function OnDelete(id){
        setOpenDialog(true)
        setActiveId(id)
      } 
      const handleDelete = ()=>{
       setIsLoader(true);
        axios.delete(`/v1/users/1/${activeId}`)
        .then(res=>{
          setOpenDialog(false)
          getUsersData()
          dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
          setIsLoader(false);
          setOpen(false)
        })
        .catch(err=>{
          dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
          console.log(err)
          setIsLoader(false);
        })
        }
const getOutletdata = () => {
  setIsLoader(true);
  axios.get('/v1/outlet/list/1')
  .then((res) => {
    setOutletData(res.data)
  setIsLoader(false);
  })
  .catch((err) => {
    dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
    console.log(err)
  setIsLoader(false);

  })
}
const getRoletdata = () => {
  setIsLoader(true);
  axios.get('/v1/role/list/1')
  .then((res) => {
    setRolestData(res.data)
  setIsLoader(false);

  })
  .catch((err) => {
    dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
    console.log(err)
  setIsLoader(false);

  })
}
console.log(outletData)
  const getUsersData = () =>{
    const url = `/v1/users/1/${rowsPerPage}/${page + 1}`
    const searchUrl = `/v1/users/1/${rowsPerPage}/${page + 1}/${search}`
  setIsLoader(true);
    axios.get(search === '' ? url : searchUrl)
    .then(res=>{
      setData(res.data.data)
      setPageCount(res.data.meta.pagination.total)
  setIsLoader(false);
    })
    .catch(err=>{
      dispatch(setSnackbar(true, 'error', "User Not Found"))
  setIsLoader(false);
    })
  }

  const handleMobile =(e)=>{
    formik.setFieldValue('mobile', e.target.value.replace(/\D/g, "").trim())
  }

  useEffect(()=>{
    getUsersData()
  },[rowsPerPage, page, search])
  useEffect(() => {
    getOutletdata()
    getRoletdata()
  },[])
  console.log(userName)
  return (
   <Grid className='' >
    <Helmet>
      <title>
        Users
      </title>
    </Helmet>
<Typography variant='h5'>Users</Typography>
{!open &&
  <Grid className='flex justify-end'>
    <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
</Grid>}
{open &&
<Modal onClose={setOpen} onSave={formik.handleSubmit} formik={formik} isEdit={isEdit}>
  <Grid container spacing={2}>
    <Grid item xs={12}>
    <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>1. User Details</Typography>

    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='userName' value={formik.values.userName} title='User Name' multiple={false} placeholder='Enter user name' onchange={formik.handleChange} errorMsg={formik.touched.userName && Boolean(formik.errors.userName)} helperText={formik.touched.userName && formik.errors.userName}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
    <Typography fontSize={16} marginBlock={.5}>Password</Typography>
    <TextField
        id="password"
        type={showPassword ? "text" : "password"}
        placeholder="Password *"
        value={formik.values.password}
        fullWidth
        size="small"
        // onKeyPress={(e) => handleEnter(e)}
        onChange={formik.handleChange}
        autoComplete="new-password"
        InputProps={{
          endAdornment: (
            <IconButton onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <Visibility /> : <VisibilityOff/>}
            </IconButton>
          ),
        }}
        error={formik.touched.password && Boolean(formik.errors.password)}
        helperText={formik.touched.password && formik.errors.password}
      />
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='email' value={formik.values.email} title='Email Id' multiple={false} placeholder='Enter email Id' onchange={formik.handleChange} errorMsg={formik.touched.email && Boolean(formik.errors.email)} helperText={formik.touched.email && formik.errors.email}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='mobile' value={formik.values.mobile} title='Mobile No' multiple={false} placeholder='Enter mobile No' onchange={handleMobile} errorMsg={formik.touched.mobile && Boolean(formik.errors.mobile)} helperText={formik.touched.mobile && formik.errors.mobile}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
    <Typography variant="body1" my={1}> User Type</Typography>
    <FormControl sx={{ display: "flex" }}>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="userType"
        id="userType"
        sx={{ flexDirection: "row", display: "flex" }}
        value={formik.values.userType}  // Add value prop to RadioGroup
        onChange={(event) => {
          formik.handleChange(event);  // Handle change event to update formik state
          if (event.target.value === "Outlet") {
            // Set the userName state based on the selected radio button value
            setUserName("Outlet"); // Replace "OutletUserName" with your desired value
          } else if (event.target.value === "Warehouse") {
            setUserName("Warehouse"); // Replace "WarehouseUserName" with your desired value
          }
        }}
      >
        <FormControlLabel
          value="Outlet"
          control={<Radio size="small" checked={formik.values.userType==='Outlet'} />}
          label="Outlet"
        />
        <FormControlLabel
          value="Warehouse"
          control={<Radio size="small"  checked={formik.values.userType==='Warehouse'}/>}
          label="Warehouse"
        />
      </RadioGroup>
      <Typography sx={{color:"red",fontSize:12}}>{formik.touched.userType && formik.errors.userType}</Typography>
    </FormControl>
    </Grid>
  <Grid item xs={12} >
    <Divider />
    </Grid>
    <Grid item xs={12}>
    <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>2. Hierarchy Details</Typography>
    </Grid>
    <Grid item xs={12} md={4} lg={3} >
    <Typography variant='body1' fontSize={17}  mb={0.8}>Outlet Mapping</Typography>
    <Autocomplete
        multiple={true}
        id="outletMapping"
        size='small'
        options={outletData}
        getOptionLabel={(option) => option.fullname}
        value={formik.values.outletMapping}
        onChange={(e, value) => {
          formik.setFieldValue("outletMapping", value);
        }}
        isOptionEqualToValue={(option, value) => option.fullname === value.fullname}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select Outlet Mapping"
            helperText={formik.touched.outletMapping && formik.errors.outletMapping}
            error={
              formik.touched.outletMapping && Boolean(formik.errors.outletMapping)
            }
          />
        )}
      />
            </Grid>
    <Grid item xs={12} md={4} lg={3} >
      <Typography variant='body1' fontSize={17}  mb={0.8}>Roles Mapping</Typography>
    <Autocomplete
      multiple={true}
      limitTags={2}
        id="rolesMapping"
        size='small'
        options={rolesData}
        getOptionLabel={(option) => option.role_name}
        value={formik.values.rolesMapping}
        onChange={(e, value) => 
      {    formik.setFieldValue("rolesMapping", value);
         }
        }
        isOptionEqualToValue={(option, value) => option.role_name === value.role_name}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select Roles Mapping"
            helperText={formik.touched.rolesMapping && formik.errors.rolesMapping}
            error={
              formik.touched.rolesMapping && Boolean(formik.errors.rolesMapping)
            }
          />
        )}
      />
      
    </Grid>
   
    {/* <Grid item xs={12} md={4} lg={3} className="flex items-center">
              <FormControlLabel control={<Checkbox />} label="Active" />
            </Grid> */}
  </Grid>
</Modal>
}
<Grid className='bg-white rounded-md p-2 my-3'>
<CustomDataGrid props={props}/>
</Grid>
<Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>
{/* <Loader isLoader={isLoader} /> */}
   </Grid>
  )
}

export default Users